import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import AccessTokenTableComponent from "../../components/panel/access-token/AccessTokenTable";
import CreateAccessTokenModal from "../../components/panel/access-token/CreateAccessTokenModal";
import { AccessTokenSchema } from "../../services/Schemas/AccessToken";
import { AccessEnums } from "../../constants/accessEnum";
import { useCanAccess } from "../../hooks/canAccess";
import ShowAccessTokenModal from "../../components/panel/access-token/ShowAccessTokenModal";

export default function AccessTokenPage() {
  const [walletReload, setWalletReload] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [openShowTokenModal, setOpenShowTokenModal] = useState(false);
  const [tokenId, setTokenId] = useState<number>(-1);
  const [tokenMode, setTokenMode] = useState<"partner" | "board">("board");

  const [tokenInfo, setTokenInfo] = useState<AccessTokenSchema | undefined>(
    undefined
  );

  const onClose = (payload: boolean) => {
    setOpenModal(payload);
    setTokenInfo(undefined);
  };

  const { can } = useCanAccess();

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                توکن های دسترسی
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                لیست توکن های دسترسی
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <Button
                variant="contained"
                disabled={!can(AccessEnums.AdminAccessTokensCreate)}
                onClick={() => setOpenModal(true)}
              >
                ایجاد توکن جدید
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <AccessTokenTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
          setOpenModal={setOpenModal}
          setTokenInfo={setTokenInfo}
          setOpenShowTokenModal={setOpenShowTokenModal}
          setTokenId={setTokenId}
        />
        <CreateAccessTokenModal
          onClose={onClose}
          handleReload={() => setWalletReload(!walletReload)}
          open={openModal}
          tokenInfo={tokenInfo}
        />
        <ShowAccessTokenModal
          onClose={setOpenShowTokenModal}
          open={openShowTokenModal}
          tokenId={tokenId}
        />
      </Stack>
    </>
  );
}
